import {Button, Input} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";


const CopyField = ({value, title, clicked, setClicked}) => {

  const [fieldTitle, setFieldTitle] = useState(title ?? "")
  const [fieldValue, setFieldValue] = useState(value);

  const [buttonValue, setButtonValue] = useState(`کپی ${fieldTitle}`)

  useEffect(() => {
    setFieldValue(value)
  }, [value]);

  useEffect(() => {
    setFieldTitle(title ?? "")
  }, [title])

  const [variant, setVariant] = useState("gradient")

  return (
    <div className="flex flex-row w-full mb-4">
      <Input
        className="textLeft pl-2 border-2 border-gray-300 rounded-lg"
        variant="standard"
        value={fieldValue}
      />
      <Button
        variant={variant}
        size="lg"
        className="p-2 mx-2 bg-blue-500 text-white rounded-lg min-w-fit"
        onClick={() => {
          navigator.clipboard.writeText(fieldValue);
          setButtonValue("کپی شد")
          toast.success(`کپی شد: ${fieldValue}`)
          if (!clicked) {
            setClicked(true)
          }
        }}
      >
        {buttonValue}
      </Button>
    </div>
  )
}

export default CopyField;
